import { Component, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { SearchSettings } from 'app/back-office/shared/models/common/search-settings.model';
import { GeneralFieldsTypeEnum } from 'app/back-office/shared/models/customer/customer.model';
import { GeneralFieldsService } from 'app/back-office/shared/services/back-office/general-fields.service';
import { FilterMapper } from 'app/back-office/shared/utilities/filter-mapper';
import { FilterItem, InternalFilterGroup } from 'app/shared/models/filter-group.models';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';

@Component({
    selector: 'app-customer-subgroup-code-filter',
    templateUrl: './customer-subgroup-code-filter.component.html',
    styleUrls: ['./customer-subgroup-code-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomerSubgroupCodeFilterComponent implements OnInit {

  @Input() filter: InternalFilterGroup;
  @Input() accordionState: boolean;
  loaderId = UtilityFunctions.newGuid();

  searchSettings: SearchSettings = {
    placeholder: 'Search customer subgroup code...',
    inputId: UtilityFunctions.newGuid(),
    showFilters: false,
    enableSearchRoute: true,
  };

  totalCount = 0;
  searchValue = '';
  cacheFilterData: FilterItem[];
  dataToView: FilterItem[] = [new FilterItem({ text: 'STATUS.ALL', value: null })];

  constructor(
    private generalFieldsService: GeneralFieldsService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.accordionState && this.accordionState && this.dataToView.length === 1) {
      this.setDataToView(0);
    }
  }

  ngOnInit(): void {
  }

  onSearch(search: string) {
    this.searchValue = search;
    if (search === '') this.dataToView = [new FilterItem({ text: 'STATUS.ALL', value: null })];
    this.setDataToView(0);
  }

  getNextData(skipCount: number) {
    if (this.totalCount > skipCount) {
      const next = skipCount ? skipCount - 1 : skipCount;
      this.setDataToView(next);
    }
  }

  setDataToView(skipCount: number) {
    const type = GeneralFieldsTypeEnum.CustomerSubGroupCode;
    (this.searchValue == undefined) ? this.searchValue = "" : null;
    this.generalFieldsService.getList(this.loaderId, this.searchValue, type, 20, 'id desc', 0).subscribe(element => {
      this.dataToView = element.items.map(el => FilterMapper.CustomerSubGroupCodeFilter(el));
      this.totalCount = element.totalCount + 1;
    });
  }

}
